module.exports = __webpack_public_path__ + "img/round-table-white.1f7c0234.svg";